import React from "react";
import {connect} from "react-redux";
import {Button, Platform, StyleSheet, Text, TextInput, TouchableOpacity, View} from "react-native";
import RecherchePicto from "../Picto/RecherchePicto";
import ClearBarreRecherche from "./ClearBarreRecherche";
import FooterRecherchePicto from "../Picto/FooterRecherchePicto";
import {wrapAction, wrapStyle} from "../../sw/helpers";

class BarreRecherche extends React.Component{

    constructor(props) {
        super(props);
        this.searchedText = this.props.text || "";
        this.state = {text : this.searchedText};
    }

    componentDidUpdate(prevProps, prevState) {
      // avoid infinite loop
      if (this.props.text !== undefined && prevProps.text != this.props.text) {
        this.setState({text: this.props.text})
      }
    }

    _setValue(text){
        this.searchedText = text;

        this.setState({ text : this.searchedText });
        this.props.search && this.props.search(text.toLowerCase());
    }

    isActive() {
      return this.props.active === undefined ? true : this.props.active;
    }

    wrapStyleIfNotActive(s) {
      return this.isActive() ? s : wrapStyle(s);
    }

    wrapActionIfNotActive(cb) {
      return this.isActive() ? cb : wrapAction(cb);
    }

    render() {
        const styles = StyleSheet.create({
            container : this.wrapStyleIfNotActive({
                flex:1,
                alignItems:"center",
                marginVertical:10,
                width:(this.props.fullScreen ? "100%" : Platform.select({ ios: "83%", android: "84%" })),
                paddingVertical: Platform.select({ ios: 20, android: 0 }),
                alignSelf: "stretch",
                flexDirection: 'row',
                alignContent: 'center',
                justifyContent: 'center',
                color : this.props.theme.colors.primary.blue1.value,
                fontFamily:this.props.theme.fonts.text,
                fontSize :14,
                //marginLeft:(this.props.fullScreen ? -10 : -5),
                borderRadius:10,
                borderWidth:1,
                borderColor : this.props.theme.colors.tertiary.black12.value,
                backgroundColor:this.props.theme.colors.tertiary.black13.value,
                position:"relative",
                marginBottom : Platform.select({ ios: 30, android: 10 }),
                paddingHorizontal:20
            }),
            recherche : {
                width: (this.props.fullScreen ? "90%" : "88%"),
                minHeight: Platform.select({ ios: 70, android: 50 }),
                //height:"100%",
                fontSize : 15,
                marginLeft: (this.props.fullScreen ? 20 : 20),
                color:this.props.theme.colors.primary.blue1.value,
            },
            picto :{
                position:"absolute",
                //top: Platform.select({ ios: -10, android: -10 }),
                left:14,
                width:20,
                height:20
            },
            touchable: {
                position: Platform.select({ ios: "absolute", android: "absolute" }),
                top: Platform.select({ ios: (this.state.text.length == 0 ? -150: 12), android: (this.state.text.length == 0 ?  -100: 12),web:(this.state.text.length == 0 ?  -100: -8)}),
                right:14,
            },
            clear : {
                position:"absolute",
                top:-1,
                right:0,
                width:17,
                height:17
            }
        });


        const active = this.isActive();

        return <View style={styles.container}>
            <FooterRecherchePicto style={styles.picto} isHeader={true}  />
            { /* fix for enterkeyhint (TODO) : https://github.com/necolas/react-native-web/pull/1707 */ }

            <TextInput enterkeyhint={"Rechercher"} value={this.state.text}
                  onChangeText={(text) =>{ this._setValue(text)}}
                  editable={active} selectTextOnFocus={active}
                  placeholderTextColor={this.props.theme.colors.tertiary.black5.value} style={styles.recherche} />

            <TouchableOpacity style={styles.touchable} onPress={this.wrapActionIfNotActive(this._setValue.bind(this,""))}>

            <ClearBarreRecherche  style={styles.clear}/>
            </TouchableOpacity>
        </View>
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(BarreRecherche);
